import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Breadcrumb from '../../components/Breadcrumb';
import CourseGridMain from './CourseGridMain';
import ScrollToTop from '../../components/ScrollTop';
import FooterTwo from '../../components/Footer/FooterTwo'

import Logo from '../../assets/images/logos/logo2.png';

const Course = () => {
    return (
        <body class="courses-grid-page">
            <Header
                parentMenu='course'
                menuCategoryEnable='enable'
                // headerNormalLogo={Logo}
                // headerStickyLogo={Logo}
                topbarEnable='enable'
            />

            <div class="react-wrapper">
                <div class="react-wrapper-inner">
                    <Breadcrumb
                        pageTitle="Courses at OCFIT"
                    />
                    

                    <CourseGridMain />

                    {/* scrolltop-start */}
                    <ScrollToTop />
                    {/* scrolltop-end */}
                </div>
            </div>

            {/* <Footer /> */}
            <FooterTwo/>

        </body>
    );
}


export default Course;

